import React from 'react';
export function Footer() {
  return <footer className="bg-[#11223A] text-gray-400 py-8 border-t border-white/10" data-id="element-102">
      <div className="container mx-auto px-4 text-center" data-id="element-103">
        <p className="text-sm" data-id="element-104">
          © {new Date().getFullYear()} Manual Académico de Lengua y Literatura.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}